import React from 'react';
import { SvgArrowIcon, SvgCheckIcon } from '../svg';

class VIDPercentage extends React.Component {

    constructor(props) {
        super(props)

        this.state = {}
    }

    componentDidMount(){
        let { contractId, addToContract, type } = this.props;
        
        addToContract(type + "allianzOwnContribution", "4.0", contractId)
        addToContract(type + "allianzEmployerContribution", "", contractId)
        addToContract(type + "otherFund", "000", contractId)
        addToContract(type + "otherFundName", "", contractId)
        addToContract(type + "otherOwnContribution", "0.0", contractId)
        addToContract(type + "otherEmployerContribution", "", contractId)
    }


    processCallback(e, contractId){
        let { type } = this.props;
        const { name, value } = e.currentTarget;
        
        // Calculate value for other
        if(name.includes("allianzOwnContribution")){
            let otherVal = 4.0 - value

            let otherEvent = { currentTarget: {name: type + 'otherOwnContribution', value: otherVal}}
            this.props.onChange(e, "split-percentage", contractId)
            this.props.onChange(otherEvent, "split-percentage", contractId)
        }
    }

    render() {
        let { customerId, VIDallianzOwnContribution, VIDotherOwnContribution, validateButtonDisplay, onChange, getFunds, contractId, values, type } = this.props;
        let id = contractId ? contractId : customerId

        return (
            <div className="card">
                <div className="group-type collapsed card-header" data-toggle="collapse" data-target={"#split-percentage-section-" + customerId} aria-expanded="false" aria-controls="split-percentage-section">
                    <button className="toggle-button">
                        {validateButtonDisplay("split-percentage", contractId, type) ? (<span className="check"><span className="check check-icon big green">
                            <SvgCheckIcon />
                        </span></span>) : (<span></span>)}
                          { this.props.heading }
                        <span className="arrow-toggle-button">
                            <SvgArrowIcon />
                        </span>
                    </button>
                </div>
                <div className="collapse" id={"split-percentage-section-" + customerId}>
                    <div className="card card-body">
                        <div className="allianz-percentage-section">
                            <div className="form-row align-items-center mt-4">
                                <div className="col-12 contribution-title">Hlutfall sem á að fara til Allianz</div>
                            </div>
                            <div className="form-row align-items-center mt-4">
                                <div className="col-sm-8">
                                    <label htmlFor={`vid-allianz-own-contribution-${customerId}`} className="col-form-label">Eigið framlag</label>
                                </div>
                                <div className="col-sm-4 text-right">
                                    <select className="custom-select col-12 col-sm-6" id={`vid-allianz-own-contribution-${customerId}`} value={VIDallianzOwnContribution} name="VIDallianzOwnContribution" onChange={(e) => this.processCallback(e, contractId)} >
                                        <option value={4.0} disabled={VIDotherOwnContribution > 0.0}>4.0%</option>
                                        <option value={3.5} disabled={VIDotherOwnContribution > 0.5}>3.5%</option>
                                        <option value={3.0} disabled={VIDotherOwnContribution > 1.0}>3.0%</option>
                                        <option value={2.5} disabled={VIDotherOwnContribution > 1.5}>2.5%</option>
                                        <option value={2.0} disabled={VIDotherOwnContribution > 2.0}>2.0%</option>
                                        <option value={1.5} disabled={VIDotherOwnContribution > 2.5}>1.5%</option>
                                        <option value={1.0} disabled={VIDotherOwnContribution > 3.0}>1.0%</option>
                                        <option value={0.5} disabled={VIDotherOwnContribution > 3.5}>0.5%</option>
                                        <option value={0.0} disabled={VIDotherOwnContribution > 4.0}>0.0%</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-row align-items-center mt-4">
                                <div className="col-sm-8">
                                    <label htmlFor={`vid-allianz-employer-contribution-${customerId}`} className="col-form-label">Mótframlag launagreiðanda</label>
                                </div>
                                <div className="col-sm-4 percentage text-right">
                                    <input type="text" className="form-control text-sm-right col-12 col-sm-6 float-right" id={`vid-allianz-employer-contribution-${customerId}`} value={values["VIDallianzEmployerContribution"]} name="VIDallianzEmployerContribution" onChange={(e) => onChange(e, "split-percentage", contractId)} />
                                </div>
                            </div>
                        </div>
                        <div className="other-fund-percentage-section">
                            <div className="form-row align-items-center mt-4">
                                <div className="col-sm-8">
                                    <label htmlFor={`vid-former-fund-${customerId}`} className="col-form-label contribution-title">Aðrir vörsluaðilar</label>
                                </div>
                                <div className="col-sm-4 text-right">
                                    {getFunds(contractId, customerId, false, "split-percentage")}
                                </div>
                            </div>
                            <div className="form-row align-items-center mt-4">
                                <div className="col-sm-8">
                                    <label htmlFor={`vid-other-own-contribution-${customerId}`} className="col-form-label">Eigið framlag</label>
                                </div>
                                <div className="col-sm-4 text-right">
                                    <select className="custom-select col-12 col-sm-6" id={`vid-other-own-contribution-${customerId}`} value={VIDotherOwnContribution} name="VIDotherOwnContribution" onChange={(e) => onChange(e, "split-percentage", contractId)} >
                                        <option value={4.0} disabled={VIDallianzOwnContribution > 0}>4.0%</option>
                                        <option value={3.5} disabled={VIDallianzOwnContribution > 0.5}>3.5%</option>
                                        <option value={3.0} disabled={VIDallianzOwnContribution > 1.0}>3.0%</option>
                                        <option value={2.5} disabled={VIDallianzOwnContribution > 1.5}>2.5%</option>
                                        <option value={2.0} disabled={VIDallianzOwnContribution > 2.0}>2.0%</option>
                                        <option value={1.5} disabled={VIDallianzOwnContribution > 2.5}>1.5%</option>
                                        <option value={1.0} disabled={VIDallianzOwnContribution > 3.0}>1.0%</option>
                                        <option value={0.5} disabled={VIDallianzOwnContribution > 3.5}>0.5%</option>
                                        <option value={0.0} disabled={VIDallianzOwnContribution > 4.0}>0.0%</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-row align-items-center mt-4">
                                <div className="col-sm-8">
                                    <label htmlFor={`vid-other-employer-contribution-${customerId}`} className="col-form-label">Mótframlag launagreiðanda</label>
                                </div>
                                <div className="col-sm-4 percentage text-right">
                                    <input type="text" className="form-control text-sm-right float-right col-12 col-sm-6" id={`vid-other-employer-contribution-${customerId}`} value={values["VIDotherEmployerContribution"]} name="VIDotherEmployerContribution" onChange={(e) => onChange(e, "split-percentage", contractId)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

VIDPercentage.defaultProps = {
    heading: "Bæta við prósentuskiptingu"
}

export default VIDPercentage;